import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime, filter, map, startWith, switchMap, tap, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  timeoutLimit = 120000; //120000 2 minutos expresados en milisegundos
  inactivityEvents = [
    'mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mousewheel',
    'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove',
    'click'
  ];

  excludedRoutes = ['/auth/*'];

  private inactivitySubscription: Subscription = new Subscription();
  private currentRoute = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {

    // this.inactivitySubscription.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.getFullRoute(this.activatedRoute)),
        debounceTime(100),
        tap(route => {
          this.currentRoute = route;
          this.restartInactivityTimer();
        })
      ).subscribe()
    // );

    this.startWatching();
  }

  ngOnInit(){

  }

  ngOnDestroy(): void {
    this.inactivitySubscription.unsubscribe();
  }

  getFullRoute(route: ActivatedRoute, urlSegments: string[] = []): string {
    const currentSegment = route.snapshot.url.map(segment => segment.path).join('/');
    if (currentSegment) {
      urlSegments.push(currentSegment);
    }

    if (route.firstChild) {
      return this.getFullRoute(route.firstChild, urlSegments);
    } else {
      return '/' + urlSegments.join('/');
    }
  }

  private isRouteExcluded(route: string): boolean {
    return this.excludedRoutes.some(excludedRoute => {
      if (excludedRoute.endsWith('/*')) {
        const baseRoute = excludedRoute.slice(0, -1);
        return route.startsWith(baseRoute);
      }

      return route === excludedRoute;
    });
  }

  private startWatching(): void {
    this.inactivitySubscription.add(
      merge(...this.inactivityEvents.map(event => fromEvent(document, event)))
        .pipe(
          startWith(null),
          switchMap(() => new Observable(observer => {
            const timeoutId = setTimeout(() => observer.next(), this.timeoutLimit);
            return () => clearTimeout(timeoutId);
          })),
          filter(() => !this.isRouteExcluded(this.currentRoute)),
          tap(() => this.router.navigate(['/screensaver'], { queryParams: { cleanCache: 'true' } }))
        )
        .subscribe()
    );
  }

  private restartInactivityTimer(): void {
    this.inactivitySubscription.unsubscribe();
    this.inactivitySubscription = new Subscription();
    this.startWatching();
  }
}
